/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { FeedFilterType, FeedFilterDirection, FeedDetails } from 'Types/index'
import { apiCall } from './api'

export const GET_FEED_TRACKS = createAsyncAction('GET_FEED_TRACKS')
export const getFeedTracks = ({
  // page,
  filterDirection,
  filterType,
}: {
  // page: number
  filterType: FeedFilterType
  filterDirection: FeedFilterDirection
}) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/feed-reviews/?page=${1}&elem_count=10&order_by=["${filterType}", "${filterDirection}"]`,
    types: GET_FEED_TRACKS,
  })

export const GET_REVIEWED_FEED_TRACKS = createAsyncAction(
  'GET_REVIEWED_FEED_TRACKS'
)
export const getReviewedFeedTracks = ({ page }: { page: number }) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/feed-reviewed/?page=${page}&elem_count=10`,
    types: GET_REVIEWED_FEED_TRACKS,
  })

export const SEND_FEED_REVIEW = createAsyncAction('SEND_FEED_REVIEW')
export const sendFeedReview = ({
  // eslint-disable-next-line camelcase
  campaign_id,
  comment,
  // eslint-disable-next-line camelcase
  value,
  callback,
}: {
  campaign_id: string
  comment: string
  value: number

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (msg?: string, err?: unknown) => void
}) =>
  apiCall({
    method: 'post',
    endpoint: '/review/feed',
    query: {
      campaign_id,
      comment,
      value,
    },
    types: SEND_FEED_REVIEW,
    callback,
  })

export const GET_FEED_DETAILS = createAsyncAction('GET_FEED_DETAILS')
export const getFeedDetails = ({
  campaign_id,
  callback,
}: {
  campaign_id: number
  callback: (error: string, response: FeedDetails) => void
}) =>
  apiCall({
    method: 'get',
    endpoint: `/review/feed-details/${campaign_id}`,
    types: GET_FEED_DETAILS,
    callback,
  })

export const SKIP_FEED_REVIEW = createAsyncAction('SKIP_FEED_REVIEW')
export const skipFeedReview = ({
  campaign_id,
  callback,
}: {
  campaign_id: string
  callback: (err: string) => void
}) =>
  apiCall({
    method: 'post',
    endpoint: `/review/feed-skip/${campaign_id}`,
    types: SEND_FEED_REVIEW,
    callback,
  })

export const RESERVE_REVIEW = createAsyncAction('RESERVE_REVIEW')
export const reserveReview = ({
  campaign_id,
  callback,
}: {
  campaign_id: string
  callback: (error: string) => void
}) =>
  apiCall({
    method: 'post',
    endpoint: `review/feed-reserve/${campaign_id}`,
    types: RESERVE_REVIEW,
    callback,
  })

export const SET_IS_RESERVED = 'SET_IS_RESERVED'
export const setIsReserved = () => ({
  type: SET_IS_RESERVED,
})
